export default __webpack_public_path__ + "static/media/complementos_4.86754de1.jpg";